<script >
import listOfservices from '../../component/cdevs/listOfservices/index.vue'

export default {
  components:{
    listOfservices
  },
  data() {
    return {
    };
  }
}
</script>

<template>
  <div class="p-6 all">
    <div>
      <listOfservices />
    </div>
  </div>
</template>

<style scoped>
.all{
  min-height: 100vh;
}
</style>
